import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import { withNotification } from "../notification/context";

const CREATE_USER = gql`
  mutation createUser($user: UserInput!) {
    createUser(user: $user) {
      id
      email
    }
  }
`;

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  }
});

const CreateUserModal = ({ classes, openNotification, query }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={CREATE_USER}
      update={(cache, { data: { createUser } }) => {
        const { allUsers } = cache.readQuery({ query });
        cache.writeQuery({
          query,
          data: { allUsers: allUsers.concat([createUser]) }
        });
      }}
    >
      {createUser => (
        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={(values, { resetForm }) => {
            createUser({ variables: { user: values } })
              .then(() => {
                openNotification("Usuario creado correctamente.");
                resetForm();
                handleClose();
              })
              .catch(() => {
                openNotification("Error creando el usuario");
                //handleClose();
              });
          }}
        >
          {({ values, handleChange, handleSubmit }) => {
            return (
              <Form>
                <Tooltip title="Crear usuario" placement="left">
                  <Fab
                    className={classes.fab}
                    color="primary"
                    onClick={handleClickOpen}
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">
                    Crear usuario
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      id="email"
                      label="Correo electrónico"
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      id="password"
                      label="Contraseña"
                      type="password"
                      value={values.password}
                      onChange={handleChange}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                      Crear
                    </Button>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      )}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(CreateUserModal);



// WEBPACK FOOTER //
// ./src/components/users/add-user-button.js